<template>
  <div class="project-form" :disabled="loading">
    <div class="title">
      {{ $tr('vacancy.settings.talentq.project-' + (created ? 'edit' : 'create')) }}
    </div>

    <vinput
      class="field"
      :placeholder="$tr('vacancy.settings.talentq.project-name')"
      :focus="true"
      :value="name"
      @input="$emit('set_name', $event)"
    />

    <slot></slot>

    <div v-if="created" class="buttons">
      <vbutton
        class="button"
        :label="$tr('actions.save')"
        :loading="loading"
        @click="$emit('save')"
      />
      <vbutton
        class="button"
        color="grey"
        :label="$tr('vacancy.settings.talentq.project-remove-button')"
        :loading="loading"
        @click="$emit('remove')"
      />
    </div>

    <vbutton
      v-else
      :label="$tr('vacancy.settings.talentq.project-create-button')"
      :loading="loading"
      @click="$emit('create')"
    />
  </div>
</template>

<script>
  export default {
    name: 'ProjectFormView',

    props: {
      loading: {
        type: Boolean,
        default: false
      },

      error: {
        type: [Error, String],
        default: false
      },

      created: {
        type: Boolean,
        default: false
      },

      name: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style scoped lang="scss">
  .project-form {
    max-width: 385px;
    min-width: 385px;
    margin: 15px 0;

    .title {
      margin: 15px 0;
      font-weight: 500;
    }

    .field {
      margin: 10px 0;

      &:first-of-type {
        margin-top: 0;
      }
    }

    .buttons {
      display: flex;
      justify-content: flex-start;

      .button {
        margin-right: 10px;
      }
    }
  }
</style>
